// extracted by mini-css-extract-plugin
export default {"productDetailBottomSheet":"ProductDetailBottomSheet_productDetailBottomSheet__DOS0O"};